function Intro({ stepNumber, stepId, stepContent, handleNextClick }) {
  const url = new URL(location);
  const state = { stepId: stepId, stepNumber: stepNumber };
  history.replaceState(state, "", url);
  return <Step stepId={stepId} stepContent={stepContent} handleNextClick={handleNextClick} />;
}
